import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ProfileFacade } from '@app/store/profile';
import { UpdateFacade } from '@app/store/update';
import { build } from '@build';
import { environment } from '@env/environment';
import { IconComponent, LogoComponent, PopupService, ScannedCodeComponent } from '@shared/components';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    host: { class: 'theme-dark' },
    providers: [PopupService],
    imports: [TranslatePipe, IconComponent, LogoComponent, RouterLink],
})
export class HeaderComponent {
    private readonly profileFacade = inject(ProfileFacade);
    private readonly updateFacade = inject(UpdateFacade);
    private readonly popupService = inject(PopupService);

    private readonly profile = this.profileFacade.profile;

    readonly updateStatus = this.updateFacade.status;

    readonly version = `v${build.version}-${environment.label}`;

    readonly userName = computed(() => this.profile()?.firstName ?? '');

    readonly userTitle = computed(() => this.profile()?.fullName ?? '');

    protected openScannedCode(): void {
        this.popupService.open(ScannedCodeComponent);
    }
}
